<template>
  <section class="app-financeiro">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-form
            ref="form"
            lazy-validation
            @submit.prevent="onSubmit"
          >
            <v-card outlined class="app-card">
              <v-card-title class="app-card-title">Gerar de Certidão Negativa</v-card-title>
              <v-card-text class="app-card-content">
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="formattedCpfCnpj"
                      label="CPF/CNPJ *"
                      :rules="[rules.required, rules.documento]"
                      maxlength="18"
                      filled
                      rounded
                      dense
                      :disabled="isLoading"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <vue-recaptcha
                    ref="recaptcha"
                    :sitekey="siteKey"
                    :loadRecaptchaScript="true"
                    @verify="verifyRecaptcha"
                    @expired="expiredRecaptcha"
                  ></vue-recaptcha>
                  <v-input
                    v-model="form.recaptcha"
                    :rules="[rules.required]"
                  ></v-input>
                <v-spacer></v-spacer>
                <v-btn depressed  large color="primary" type="submit" :disabled="isLoading"
                        >Continuar</v-btn
                      >
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import certidaoNegativaService from '@/services/financeiro/certidao-negativa.service';
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import {
  detectTipoPessoa,
  formatDocumentoInput,
  normalizeDocumentoInput,
  validateDocumentoInput
} from "@/helpers/documento-identificacao.helper";
export default {
  metaInfo: {
    title: "Gerar Certidão Negativa - Financeiro - Central de Serviços"
  },

  components: {
    VueRecaptcha
  },

  data: () => ({
    siteKey: VUE_APP_RECAPTCHA_KEY,

    form: {
      recaptcha: null,
      cpfCnpj: null
    },

    rules: {
      required: value => !!value || "Esse campo deve ser preenchido",
      documento: value =>
        validateDocumentoInput(value, detectTipoPessoa(value)) || "CPF/CNPJ inválido"
    },

    isLoading: false,
  }),

  computed: {
    formattedCpfCnpj: {
      get() {
        return this.form.cpfCnpj;
      },
      set(value) {
        this.form.cpfCnpj = formatDocumentoInput(value, detectTipoPessoa(value));
      }
    }
  },

  methods: {
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        const { recaptcha } = this.form
        const cpfCnpj = normalizeDocumentoInput(this.form.cpfCnpj, detectTipoPessoa(this.form.cpfCnpj))
        this.isLoading = true
        certidaoNegativaService.generatePdf(recaptcha, cpfCnpj).subscribe((res)=>{
          this.download(res, `certidao-negatica-${cpfCnpj}.pdf`)
          this.isLoading = false
        },(err)=>{
          this.isLoading = false
        })
      }
    },

    download(data, filename) {
      const blob = new Blob([data], {
        type: "application/pdf",
        fileName: filename
      });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    },

    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },

    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
  }
};
</script>
